export default function getDate() {
  const times = new Date().toLocaleString().split(' ')
  const time = times[1]
  const ymd = times[0].split('/') //年月日
  const year = parseInt(ymd[0])
  const month = parseInt(ymd[1]) > 9 ? parseInt(ymd[1]) : `0${parseInt(ymd[1])}`
  const day = parseInt(ymd[2]) > 9 ? parseInt(ymd[2]) : `0${parseInt(ymd[2])}`
  return year + '-' + month + '-' + day + ' ' + time
}
